export default function JobOverlayActivities({ isOpen, onClickGritAndFit, onClickQuizz, mini = false }) {
  return (
    <div className={`
        absolute inset-0 bg-gray-900 rounded-xl transition-all duration-3000 flex items-center justify-center visible
        ${isOpen ? ' bg-opacity-60 visible backdrop-blur-sm ' : 'opacity-0 invisible'} `}>
      {/* Layer central */}
      <div className="relative z-10 rounded-xl p-6 w-full max-w-4xl mx-4">
        <div className="flex justify-center gap-4 mb-4">
          <button className="flex items-center gap-2  bg-teal-500 text-white font-semibold px-6 py-3 rounded-xl text-sm whitespace-nowrap"
            onClick={onClickGritAndFit}>
            🎮 {mini ? '' : 'Dans la peau d\'un pro'}
          </button>
          <button className="flex items-center gap-2  bg-teal-500/50 text-white font-semibold px-6 py-3 rounded-xl text-sm whitespace-nowrap"
            onClick={onClickQuizz}>
            🎯 {mini ? '' : 'Quizz'}
          </button>
        </div>
        {!mini && <p className="text-center text-xs text-slate-400">Tape pour fermer</p>}
      </div>
    </div>
  );
}
